export default __webpack_public_path__ + "static/media/54e560cd.svg";